var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"language-button"},[_c('select',{attrs:{"id":"lang-select"},on:{"click":_vm.getId}},[_c('option',{attrs:{"value":"bg"}},[_vm._v(" Bg ")]),_c('option',{attrs:{"value":"en"}},[_vm._v(" En ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }